import { useMutation, useQueryClient } from '@tanstack/react-query';
import { SSF } from '~/apis/api';

export function useLogoutMutation() {
  const client = useQueryClient();

  return useMutation({
    mutationFn: () => SSF.api.authLogoutCreate(),
    onSuccess: () => client.clear(),
  });
}
